import { useTranslation } from 'react-i18next';
import { HeaderActionType } from '../../../SharedComponents/Header/HeaderActionType';
import { HeaderResource } from '../../../Utils/PageUtils';

type HearingAssessmentInstructionResource = {
    header: HeaderResource;

    instructionTitle: {
        id: string;
        text: string;
    };

    instructionGeneral: {
        id: string;
        text: string;
    };

    instruction: {
        id: string;
        text: string;
    };

    startButton: {
        id: string;
        text: string;
    };
};

export default function useHearingAssessmentInstructionResource(): HearingAssessmentInstructionResource {
    const { t } = useTranslation();

    const header = {
        id: 'header-hlaa-instruction',
        text: t('common:Common_Feature:HearingProfileCheck'),
        type: HeaderActionType.Menu,
    };

    const instructionTitle = {
        id: 'txt-title',
        text: t('hlaa:Hlaa_Feature:instruction:TitleText'),
    };

    const instructionGeneral = {
        id: 'txt-instruction-general',
        text: t('hlaa:Hlaa_Feature:instruction:Text1'),
    };

    const instruction = {
        id: 'txt-instruction',
        text: t('hlaa:Hlaa_Feature:instruction:Text2'),
    };

    const startButton = {
        id: 'btn-start-assessment',
        text: t('common:Common_Feature:Continue'),
    };

    return {
        header,
        instructionTitle,
        instructionGeneral,
        instruction,
        startButton,
    };
}
